export const defaultCreditCost = parseInt(
  process.env.NEXT_PUBLIC_DEFAULT_GENERATE_COST,
);
